"use client";

import { PDFDownloadLink } from "@react-pdf/renderer";
import InternationalPdf from "./InternationalPdf";
const InternationalWeddingQuotationPdf = ({ pdfData }) => {
  const fileName = "InternationalWeddingQuotation.pdf";
  return (
    <div>
      {/* <PDFViewer width={800} height={500} showToolbar={false}>
                <PdfDocument  pdfData={pdfData} />
            </PDFViewer> */}
      <div className="download-link">
        <PDFDownloadLink
          document={
            <InternationalPdf
              pdfData={pdfData?.quotation_details}
              mob_no_status={pdfData?.mob_no_status}
            />
          }
          fileName={fileName}
          style={{ color: "#fff", textDecoration: "none" }}
        >
          <center>
            <button className="btn btn-success text-white my-3">
              Download International Quotation
            </button>
          </center>
        </PDFDownloadLink>
      </div>
    </div>
  );
};

export default InternationalWeddingQuotationPdf;
